module.exports = __webpack_public_path__ + "media/screenshot.d5fb3f65.mp3";